// source: pbtypes/gen/wifi_service/wireless_channel_band_list.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.wifi_service.WirelessChannelBandList', null, global);
goog.exportSymbol('proto.wifi_service.WirelessChannelBandList.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wifi_service.WirelessChannelBandList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wifi_service.WirelessChannelBandList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wifi_service.WirelessChannelBandList.displayName = 'proto.wifi_service.WirelessChannelBandList';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wifi_service.WirelessChannelBandList.prototype.toObject = function(opt_includeInstance) {
  return proto.wifi_service.WirelessChannelBandList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wifi_service.WirelessChannelBandList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wifi_service.WirelessChannelBandList.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wifi_service.WirelessChannelBandList}
 */
proto.wifi_service.WirelessChannelBandList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wifi_service.WirelessChannelBandList;
  return proto.wifi_service.WirelessChannelBandList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wifi_service.WirelessChannelBandList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wifi_service.WirelessChannelBandList}
 */
proto.wifi_service.WirelessChannelBandList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wifi_service.WirelessChannelBandList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wifi_service.WirelessChannelBandList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wifi_service.WirelessChannelBandList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wifi_service.WirelessChannelBandList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.wifi_service.WirelessChannelBandList.Enum = {
  INVALID: 0,
  BAND_5_GHZ_UNII_ONE_THREE: 1,
  BAND_2_GHZ: 2,
  BAND_5_GHZ_DFS: 3,
  BAND_5_GHZ_UNII_ONE: 4,
  BAND_5_GHZ_UNII_THREE: 5,
  BAND_5_GHZ_JP_ROBOTICS: 6,
  BAND_5_GHZ_UNII_TWO_A: 7,
  BAND_5_GHZ_UNII_TWO_C: 8,
  BAND_5_GHZ_UNII_FOUR: 9,
  BAND_5_GHZ_UNII_FIVE: 10,
  AUTO: 11
};

goog.object.extend(exports, proto.wifi_service);
